import { useEffect } from 'react';
import { IEcosystem } from 'ui/types/ecosystem';

import { useAppDispatch } from '~/hooks/useAppDispatch';
import { useAppSelector } from '~/hooks/useAppSelector';
import { authSliceActions } from '~/store/slices/auth';
import { ecosystemSliceActions } from '~/store/slices/ecosystem';

import { useQuery } from '../useQuery';

export const useEcosystemRefresh = ({ enabled }: { enabled: boolean }) => {
  const { selectedUserProfile } = useAppSelector(({ auth }) => auth);
  const { selectedEcosystem } = useAppSelector(({ ecosystem }) => ecosystem);

  const dispatch = useAppDispatch();

  const { data: ecosystem } = useQuery<IEcosystem>(
    `/ecosystem/${selectedEcosystem?._id}`,
    {
      queryOptions: {
        enabled: !!selectedEcosystem?._id && enabled,
        cacheTime: 0,
      },
    },
  );

  useEffect(() => {
    if (ecosystem) {
      dispatch(ecosystemSliceActions.resetEcosystem());

      dispatch(
        ecosystemSliceActions.selectEcosystem({
          ecosystem,
          isDefaultEcosystem: false,
        }),
      );

      dispatch(
        authSliceActions.update({
          selectedUserProfile: {
            ...selectedUserProfile,
            ecosystem: ecosystem._id,
          },
          redirectToSwitchProfile: false,
        }),
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ecosystem]);
};
